import React, { useState, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from '../context/FormContext';
import { isValidDateFormat } from '../utils/validation';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CTAButton from '../components/CTAButton';
import SecurityBadges from '../components/SecurityBadges';

const Birthdate: React.FC = () => {
  const { formData, updateFormData, nextStep } = useFormContext();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<{
    birthdate?: string;
  }>({});

  const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    
    // Only allow numbers and dots
    value = value.replace(/[^\d.]/g, '');
    
    // Limit to 10 characters (DD.MM.YYYY)
    value = value.slice(0, 10);
    
    updateFormData('birthdate', value);
  };

  const validateForm = () => {
    const newErrors: { birthdate?: string } = {};
    
    if (!formData.birthdate) {
      newErrors.birthdate = 'Bitte geben Sie das Geburtsdatum ein';
    } else if (!isValidDateFormat(formData.birthdate)) {
      newErrors.birthdate = 'Bitte geben Sie das Datum im Format TT.MM.JJJJ ein';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validateForm()) {
      await nextStep({
        birthdate: formData.birthdate
      });
      navigate('/email');
    }
  };

  const handleBack = () => {
    navigate('/known-info');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          <h2 className="text-2xl text-center font-semibold text-deep-blue mb-8">
            Angabe zum Geburtsdatum:
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="birthdate" className="block text-sm font-medium text-gray-700 mb-1">
                Geburtsdatum (Beispiel: 01.01.1990)
              </label>
              <input
                type="text"
                id="birthdate"
                placeholder="01.01.1980"
                className="input-field"
                value={formData.birthdate}
                onChange={handleDateChange}
              />
              {errors.birthdate && <p className="mt-1 text-sm text-red-600">{errors.birthdate}</p>}
            </div>
            
            <div className="mt-8 flex justify-between">
              <CTAButton 
                type="button"
                text="Zurück" 
                back={true}
                onClick={handleBack}
                className="w-[48%]" 
              />
              <CTAButton 
                type="submit"
                text="Weiter" 
                arrow={true}
                className="w-[48%]" 
              />
            </div>
          </form>
        </div>
        
        <SecurityBadges />
      </main>
      
      <Footer />
    </div>
  );
};

export default Birthdate;
